import styled from "styled-components";

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 11.25rem;
  width: 100%;
  background-color: #f5f6f7;
  color: #0066ff;
  border: none;
  margin: 0 15px;
  font-size: 2em;
  padding:0;
  margin:0.2rem;
`;